"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleValue = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SingleValue = function SingleValue(props) {
  var data = props.data;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.SingleValue, props, /*#__PURE__*/_react["default"].createElement("span", null, "\u0438\u0437 ", data.selectedLabel));
};

exports.SingleValue = SingleValue;